/* ============================================================
   DESIGN BY CHAZ — THEME JS  v4
   ============================================================ */

'use strict';

/* ── Cart State ────────────────────────────────────────────── */
let cartState = { items: [], item_count: 0, total_price: 0 };
let selectedVariantId = null;
let bundleQty = 1;

/* ── Init ──────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  initLazyImages();
  fetchCartState();

  // Set initial selected variant
  const hiddenVariant = document.getElementById('selected-variant-id');
  if (hiddenVariant) selectedVariantId = hiddenVariant.value;

  const firstVariantBtn = document.querySelector('.variant-btn.selected');
  if (firstVariantBtn) selectedVariantId = firstVariantBtn.dataset.variantId;

  // Track + render recently viewed
  if (window.productData) {
    trackRecentlyViewed(window.productData);
    renderRecentlyViewed();
  }

  // Email popup
  initEmailPopup();

  // Countdown timers (password page + optional homepage)
  initCountdowns();
});

/* ── Lazy Images ───────────────────────────────────────────── */
function initLazyImages() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('img.lazy').forEach(function (img) {
      if (img.dataset.src) { img.src = img.dataset.src; img.classList.add('loaded'); img.classList.remove('lazy'); }
    });
    return;
  }
  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      const img = entry.target;
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.classList.add('loaded');
        img.classList.remove('lazy');
        obs.unobserve(img);
      }
    });
  }, { rootMargin: '200px' });
  document.querySelectorAll('img.lazy').forEach(function (img) { obs.observe(img); });
}

/* ── Mobile Menu ───────────────────────────────────────────── */
function toggleMobileMenu() {
  const overlay = document.getElementById('mobile-menu-overlay');
  const hamburger = document.querySelector('.hamburger');
  const isOpen = overlay.classList.contains('is-open');
  if (isOpen) {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  } else {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }
}

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  if (mobileOverlay && mobileOverlay.classList.contains('is-open')) toggleMobileMenu();
  closeCartDrawer();
  closeEmailPopup();
});

/* ── Cart Drawer ───────────────────────────────────────────── */
function openCartDrawer() {
  fetchCartState().then(function () { renderCartDrawer(); });
  document.getElementById('cart-drawer').classList.add('is-open');
  document.getElementById('cart-drawer-overlay').classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('is-open');
  document.body.style.overflow = '';
}

function fetchCartState() {
  return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartState = cart;
      updateCartCounts(cart.item_count);
      return cart;
    })
    .catch(function (err) { console.error('Cart fetch:', err); });
}

function updateCartCounts(count) {
  document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
}

function renderCartDrawer() {
  const itemsEl = document.getElementById('cart-drawer-items');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const upsellEl = document.getElementById('cart-upsell-prompt');
  if (!itemsEl) return;

  if (cartState.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-drawer__empty">YOUR CART IS EMPTY.</div>';
    if (subtotalEl) subtotalEl.textContent = '—';
    if (upsellEl) upsellEl.innerHTML = '';
    return;
  }

  let html = '';
  let hasDeck = false;
  let hasBrix = false;

  cartState.items.forEach(function (item) {
    const imgSrc = item.image
      ? item.image.replace(/(_\d+x\d+)?\.(\w+)(\?.*)?$/, '_140x140.$2')
      : '';

    html += `
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}">
          ${imgSrc
            ? `<img class="cart-item__img" src="${imgSrc}" alt="${escapeHtml(item.title)}" width="70" height="70" loading="lazy">`
            : `<div class="cart-item__img" style="background:#0d0d0d;"></div>`
          }
        </a>
        <div class="cart-item__details">
          <a href="${item.url}" class="cart-item__title">${item.title.toUpperCase()}</a>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<span class="cart-item__variant">${item.variant_title.toUpperCase()}</span>`
            : ''}
          <div class="cart-item__qty">
            <button class="cart-item__qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span class="cart-item__qty-value">${item.quantity}</span>
            <button class="cart-item__qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
          <button class="cart-item__remove" onclick="updateCartItem('${item.key}', 0)">REMOVE</button>
        </div>
        <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
      </div>`;

    // Detect product types for cross-sell
    const h = (item.handle || '').toLowerCase();
    const t = (item.product_type || '').toLowerCase();
    if (h.includes('deck') || t.includes('deck')) hasDeck = true;
    if (h.includes('brix') || t.includes('brix') || h.includes('sneaker')) hasBrix = true;
  });

  itemsEl.innerHTML = html;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cartState.total_price);

  // Cross-sell prompt
  if (upsellEl) {
    const cfg = window.dbcTheme || {};
    if (hasDeck && cfg.crosssellMiniVariantId) {
      upsellEl.innerHTML = `
        <div class="cart-upsell">
          <div class="cart-upsell__inner">
            <p class="cart-upsell__text">ADD A MINI SKATEBOARD — <strong>£15</strong></p>
            <button class="cart-upsell__btn" onclick="addCrosssell('${cfg.crosssellMiniVariantId}')">+ ADD</button>
          </div>
        </div>`;
    } else if (hasBrix && cfg.crosssellDeckVariantId) {
      upsellEl.innerHTML = `
        <div class="cart-upsell">
          <div class="cart-upsell__inner">
            <p class="cart-upsell__text">COMPLETE THE SET — <strong>ADD A DECK</strong></p>
            <button class="cart-upsell__btn" onclick="addCrosssell('${cfg.crosssellDeckVariantId}')">+ ADD</button>
          </div>
        </div>`;
    } else {
      upsellEl.innerHTML = '';
    }
  }
}

function addCrosssell(variantId) {
  if (!variantId) return;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function () { fetchCartState().then(renderCartDrawer); })
    .catch(function (err) { console.error('Cross-sell add:', err); });
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartState = cart;
      updateCartCounts(cart.item_count);
      renderCartDrawer();
    })
    .catch(function (err) { console.error('Cart update:', err); });
}

/* ── Add to Cart ───────────────────────────────────────────── */
function addToCart() {
  const btn = document.getElementById('add-to-cart-btn');
  if (!btn) return;
  const variantId = selectedVariantId || btn.dataset.variantId;
  if (!variantId) return;
  const qty = bundleQty || 1;

  btn.textContent = 'ADDING...';
  btn.classList.add('loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
    .then(function (r) { if (!r.ok) throw new Error('Failed'); return r.json(); })
    .then(function () {
      btn.textContent = 'ADDED';
      setTimeout(function () {
        btn.textContent = qty === 1 ? 'ADD TO CART' : `ADD ${qty} DECKS TO CART`;
        btn.classList.remove('loading');
      }, 1200);
      openCartDrawer();
    })
    .catch(function (err) {
      console.error('Add to cart:', err);
      btn.textContent = 'ERROR — TRY AGAIN';
      btn.classList.remove('loading');
      setTimeout(function () { btn.textContent = 'ADD TO CART'; }, 2000);
    });
}

/* ── Variant Selection ─────────────────────────────────────── */
function selectVariant(btn) {
  if (btn.dataset.available === 'false') return;
  document.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  selectedVariantId = btn.dataset.variantId;
  const priceEl = document.getElementById('product-price');
  if (priceEl && btn.dataset.price) priceEl.textContent = formatMoney(parseInt(btn.dataset.price, 10));
  const atcBtn = document.getElementById('add-to-cart-btn');
  if (atcBtn) atcBtn.dataset.variantId = selectedVariantId;
}

/* ── Bundle Selection ──────────────────────────────────────── */
function selectBundle(qty, row) {
  bundleQty = qty;
  document.querySelectorAll('.bundle-row').forEach(function (r) { r.classList.remove('selected'); });
  if (row) row.classList.add('selected');
  const atcBtn = document.getElementById('add-to-cart-btn');
  if (atcBtn) {
    atcBtn.textContent = qty === 1 ? 'ADD TO CART' : `ADD ${qty} DECKS TO CART`;
  }
}

/* ── Product Gallery ───────────────────────────────────────── */
function switchProductImage(thumb) {
  const mainImg = document.getElementById('product-main-img');
  if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
  document.querySelectorAll('.product-page__thumb').forEach(function (t) { t.classList.remove('active'); });
  thumb.classList.add('active');
}

/* ── Recently Viewed ───────────────────────────────────────── */
var RV_KEY = 'dbc_recently_viewed';
var RV_MAX = 10;

function trackRecentlyViewed(product) {
  try {
    var existing = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    // Remove current product if already stored
    existing = existing.filter(function (p) { return p.id !== product.id; });
    // Prepend current
    existing.unshift({
      id: product.id,
      handle: product.handle,
      title: product.title,
      price: product.price,
      image: product.image,
      url: product.url
    });
    // Cap at max
    existing = existing.slice(0, RV_MAX);
    localStorage.setItem(RV_KEY, JSON.stringify(existing));
  } catch (e) {
    // localStorage blocked — silently skip
  }
}

function renderRecentlyViewed() {
  var container = document.getElementById('recently-viewed');
  var grid = document.getElementById('recently-viewed-grid');
  if (!container || !grid) return;

  var currentId = parseInt(container.dataset.current, 10);

  try {
    var products = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    // Exclude current product, take up to 3
    var toShow = products.filter(function (p) { return p.id !== currentId; }).slice(0, 3);
    if (toShow.length === 0) return;

    var html = toShow.map(function (p) {
      return `
        <div class="product-grid__item">
          <a href="${p.url}" class="product-card">
            <div class="product-card__media">
              ${p.image
                ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" class="product-card__img lazy" data-src="${p.image}" width="400" height="400" loading="lazy">`
                : `<div style="width:100%;aspect-ratio:1/1;background:#0d0d0d;"></div>`
              }
            </div>
            <div class="product-card__info">
              <h2 class="product-card__title">${p.title.toUpperCase()}</h2>
              <div class="product-card__price">${formatMoney(p.price)}</div>
            </div>
          </a>
        </div>`;
    }).join('');

    grid.innerHTML = html;
    container.style.display = 'block';
    initLazyImages();
  } catch (e) {
    // localStorage blocked — silently skip
  }
}

/* ── Email Popup ───────────────────────────────────────────── */
function initEmailPopup() {
  var cfg = window.dbcPopupConfig;
  if (!cfg) return;

  // Check cookie
  if (getCookie(cfg.cookieName)) return;

  setTimeout(function () {
    var overlay = document.getElementById('email-popup-overlay');
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Load Klaviyo form if configured
    if (cfg.klaviyoFormId && window._klOnsite) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', cfg.klaviyoFormId]);
    }
  }, cfg.delay);
}

function dismissPopup() {
  var overlay = document.getElementById('email-popup-overlay');
  if (!overlay) return;
  overlay.classList.remove('is-open');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';

  var cfg = window.dbcPopupConfig;
  if (cfg) setCookie(cfg.cookieName, '1', cfg.cookieDays);
}

function closeEmailPopup() {
  var overlay = document.getElementById('email-popup-overlay');
  if (overlay && overlay.classList.contains('is-open')) dismissPopup();
}

// Mark as seen when form submitted
document.addEventListener('submit', function (e) {
  if (e.target && (e.target.id === 'popup-newsletter-form')) {
    var cfg = window.dbcPopupConfig;
    if (cfg) setCookie(cfg.cookieName, '1', cfg.cookieDays);
  }
});

/* ── Countdown Timer ───────────────────────────────────────── */
function initCountdowns() {
  var cfg = window.dbcTheme || {};
  var targetStr = cfg.countdownDate;

  // Also check password page data attribute
  var pwEl = document.getElementById('countdown-timer');
  if (pwEl && pwEl.dataset.date) targetStr = pwEl.dataset.date;

  if (!targetStr) return;

  var target = new Date(targetStr).getTime();
  if (isNaN(target)) return;

  function tick() {
    var now = Date.now();
    var diff = target - now;

    if (diff <= 0) {
      setCountdownDisplay(0, 0, 0, 0);
      return;
    }

    var days  = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins  = Math.floor((diff % 3600000) / 60000);
    var secs  = Math.floor((diff % 60000) / 1000);

    setCountdownDisplay(days, hours, mins, secs);
    setTimeout(tick, 1000);
  }

  tick();
}

function setCountdownDisplay(days, hours, mins, secs) {
  function pad(n) { return String(n).padStart(2, '0'); }
  var els = {
    days:  document.getElementById('cd-days'),
    hours: document.getElementById('cd-hours'),
    mins:  document.getElementById('cd-mins'),
    secs:  document.getElementById('cd-secs')
  };
  if (els.days)  els.days.textContent  = pad(days);
  if (els.hours) els.hours.textContent = pad(hours);
  if (els.mins)  els.mins.textContent  = pad(mins);
  if (els.secs)  els.secs.textContent  = pad(secs);

  // Homepage countdown (optional separate element)
  var hpDays  = document.getElementById('hp-cd-days');
  var hpHours = document.getElementById('hp-cd-hours');
  var hpMins  = document.getElementById('hp-cd-mins');
  var hpSecs  = document.getElementById('hp-cd-secs');
  if (hpDays)  hpDays.textContent  = pad(days);
  if (hpHours) hpHours.textContent = pad(hours);
  if (hpMins)  hpMins.textContent  = pad(mins);
  if (hpSecs)  hpSecs.textContent  = pad(secs);
}

/* ── Cookie Helpers ────────────────────────────────────────── */
function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + d.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
}

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

/* ── Utilities ─────────────────────────────────────────────── */
function formatMoney(cents) {
  if (typeof cents === 'string') cents = parseInt(cents, 10);
  return '£' + (cents / 100).toFixed(2);
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
